import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { AmountInformationArea, CardInformationArea, CustomerInformationArea, CustomerSelect, FirmDescriptionArea, FirmInformationArea, GroupTitle, HtmlTableButton, InstallmentListV1, PaymentContractArea, PaymentDescriptionArea, PaymentMasterArea, PaymentResultV1, RouteErrorByStatus, ThreedPopup } from "../components";
import PaymentProvidersV1 from "../components/Payment/PaymentProvidersV1";
import { PaymentCustomerInformationType } from "../../common/types";
import { Button, Checkbox, } from "../components/Elements";
import { isAmountValid, paymentHelpers, removeAmountDots, selectEnExpiredPaymentLinkInformations, selectPaymentApiPageInformations, selectPaymentLinkInformations } from "../../common/helpers/paymentHelpers";
import { AmountInfoRefProp } from "../components/Payment/AmountInformationArea";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import paymentApi from "../../common/api/paymentApi";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../components/Loading";
import { InitialPaymentInformations, InstallmentListType, LinkHashStatuses, PaymentProviderListType, PaymentResultParams, ThreedPopupRefProp } from "../../common/types/PaymentTypes";
import { CardInformationRef } from "../components/Payment/CardInformationArea";
import { IS_BANK_USER, USER_ID, USER_IDENTITY, USER_PERMISSIONS } from "../../constants/storageKeys";
import { PaymentValidationType, updatePaymentValidationErrors } from "../../store/slices/paymentPageSlice";
import { ThunkDispatch } from "redux-thunk";
import { formatCurrency } from "../../lib/helpers";
import { isValidEmailAddress } from "../../common/helpers/globalHelpers";
import { PaymentDescriptionRef } from "../components/Payment/PaymentDescriptionArea";
import { useRecoilValue } from "recoil";
import { tenantState } from "../../store/recoil/tenant/atoms";
import PageTitle from "../components/PageTitle";
import { pageTitleTexts } from "../../constants/texts/pageTitleTexts";
import { RootStateType } from "../../store/RootState";
import { getParameters } from "../../store/slices/parametersSlice";
import { getUserIdentity, isAuthorizeToComission, isAuthorizeToFreePayment, isUserAuthorizeToMenu } from "../../common/helpers/authorizationHelper";
import moment from "moment";
import { UserOperationTypes } from "../../common/types/AuthorizationProps";
import { getCurrencySymbolByCurrencyId } from "../../common/helpers/getCurrencySymbolByCurrencyId";
import CustomerAmountInformationArea from "../components/Payment/CustomerAmountInformationArea";
import { ApiResponseType } from "../../common/api/apiHelper";
import commonNetwork from "../../common/api/commonNetwork";
import { isCommissionSelectable } from "../../common/helpers/isCommissionSelectable";
import { usePermissionCheck } from "../../hooks/usePermissionCheck";
import CostArea from "../components/Payment/CostArea";

const initialCustomerInfo: PaymentCustomerInformationType = {
  address: "",
  city: "",
  country: "",
  customerCode: "",
  customerId: 0,
  customerName: "",
  district: "",
  email: "",
  phone: "",
  taxCode: "",
  taxOffice: "",
  tcCode: "",

}

const initialPaymentInfoState = {
  paymentProviderId: 0,
  isPaymentProviderSelectable: false,
  isAmountEditable: true,
  paymentDescriptionVisible: true,
  paymentDescriptionRequired: true,
  PaymentDescriptionIninitalValue: "",
  description: "",
  longDescription: "",
  enableInstallments: [],
  logoUrl: "",
  payButtonTitle: "Öde",
  firmKvkkText: "",
  isShowInstallmentHtmlTable: true,
  manufacturerCard: "False",
  isApplyComission: true,
  currencyId: 1,
}

const initialFirmState = {
  email: "",
  firmShortName: "",
  taxCode: "",
  web: "",
  firmLogourl: "",
};

const initialInvoiceState = {
  invoiceNumber: "",
  gibInvoiceNumber: "",
  invoiceDate: null,
  invoicePaymentDate: null,
  invoiceDay: 0
}

const PaymentPageV1 = () => {
  var userId = localStorage.getItem(USER_ID);
  usePermissionCheck(UserOperationTypes["Ödeme Al"], "Ödeme Alma izni yok");
  const [searchParams, setSearchParams] = useSearchParams();
  const queryParameters = new URLSearchParams(decodeURIComponent(window.location.search))
  const navigate = useNavigate();

  const tenantValue = useRecoilValue(tenantState);
  const { licenseKey, taxCode, firmName, logoPath, email, web, isShowCost } = tenantValue.firmInformations;

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const { parameters } = useSelector((state: any) => state.parameters);

  const url = window.location.href;
  const paymentPage = paymentHelpers.getPaymentPageType(url);
  const isWebPortal = paymentPage == "portal";
  const isApiPayment = paymentPage == "apiPage";
  const isPaymentLink = paymentPage == "paymentLink";
  const isPublicPayment = paymentPage == "publicPayment";
  const isUnexpiredPaymentPage = paymentPage == "unexpiredLink";
  const isOnlyManuelCustomer = isPublicPayment || isUnexpiredPaymentPage;

  const threedPopupRef = useRef<ThreedPopupRefProp>(null);
  const amountInformationRef = useRef<AmountInfoRefProp>(null);
  const cardInformationRef = useRef<CardInformationRef>(null);
  const paymentDescriptionRef = useRef<PaymentDescriptionRef>(null);

  const [initialLoadingVisible, setInitialLoadingVisible] = useState(!isWebPortal);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [inputAmount, setInputAmount] = useState("");
  const [selectedInstallment, setSelectedInstallment] = useState(0);
  const [installmentList, setInstallmentList] = useState<Array<InstallmentListType>>([]);
  const [selectedCustomerInfo, setSelectedCustomerInfo] = useState<PaymentCustomerInformationType>(initialCustomerInfo);
  const [licenseInfo, setLicenseInfo] = useState({
    licenseKey: "",
    taxCode: ""
  });
  const [invoiceNumber, setInvoiceNumber] = useState<string>("");
  const [initialPaymentInformations, setInitialPaymentInformations] = useState<InitialPaymentInformations>(initialPaymentInfoState);
  const [firmInformations, setFirmInformations] = useState(initialFirmState);
  const [invoiceInformations, setInvoiceInformations] = useState(initialInvoiceState);
  const [linkStatus, setlinkStatus] = useState<LinkHashStatuses>("");
  const [disablePost, setDisablePost] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [installmentLoading, setInstallmentLoading] = useState(false);
  const [installmentLimitError, setInstallmentLimitError] = useState("");
  const [isDynamicPaymentProvider, setIsDynamicPaymentProvider] = useState<boolean>(false);
  const currencyList = useSelector((state: RootStateType) => state.firmCurrencyList.currencyList);
  const [currencyIsoCode, setCurrencyIsoCode] = useState<string>("");
  const [paymentComplete, setPaymentComplete] = useState(false);
  const [completedPaymentParameters, setCompletedPaymentParameters] = useState<PaymentResultParams>({
    Orderid: 0,
    Amount: "",
    Installment: 0,
    Status: "fail",
    TransactionId: "",
    ErrorCode: "",
    ErrorMessage: "",
    ReferenceNumber: "",
    PaymentId: "",
    paymentPageType: "portal",
    CurrencySymbol: "₺"
  });
  const [paymentLinkHash, setPaymentLinkHash] = useState("");
  const [sendTypeId, setSendTypeId] = useState<number>(0);
  const [apiInfo, setApiInfo] = useState({
    apiKey: "",
    apiSecret: ""
  });
  const [amountForView, setAmountForView] = useState<any>();
  const [isUserVp, setIsUserVp] = useState<boolean>(false);
  const [defaultUserVp, setDefaultUserVp] = useState<number>(0);
  const [netAmount, setNetAmount] = useState("");
  const [serviceCommissionRate, setServiceCommissionRate] = useState("");
  const [serviceCommissionAmount, setServiceCommissionAmount] = useState("");
  const isFirmInfoVisible = paymentHelpers.isFirmInfoVisible(paymentPage);
  const isCustomerSelectVisible = paymentHelpers.isCustomerSelectVisible(paymentPage);
  const headerNavVisible = paymentHelpers.isHeaderNavVisible(paymentPage);
  const isAmountAreaVisible = paymentHelpers.isPaymentAmountAreaVisible(paymentPage);
  const customerInformationVisible = (!isPublicPayment) && selectedCustomerInfo.isManuelInput != true;
  const isBankUser = localStorage.getItem(IS_BANK_USER) == "true";

  useLayoutEffect(() => {
    handleUserPaymentPermissions();
  }, [])

  useEffect(() => {
    amountInformationRef.current?.selectBalance();
  }, [selectedCustomerInfo.customerId]);

  useEffect(() => {
    dispatch(updatePaymentValidationErrors([]));
    dispatch(getParameters());

    if (isPaymentLink) {
      selectLinkInformations();
    } else if (isApiPayment) {
      selectApiPageInformations();
    } else if (isPublicPayment) {
      selectPublicPaymentInfo();
    } else if (isUnexpiredPaymentPage) {
      selectUnexpiredLinkInformations();
    } else {
      selectTenantInformations();
    }
  }, [tenantValue.firmInformations]);

  useEffect(() => {
    if (isAmountValid(inputAmount)) {
      selectInstallmentList();
    }
  }, [inputAmount, initialPaymentInformations.currencyId, initialPaymentInformations.isApplyComission, selectedCustomerInfo.customerId]);

  useEffect(() => {
    const cardBin = cardInformationRef.current?.getCardBin() || "";
    if (cardBin.length < 8) {
      setAmountForView(inputAmount);
    }
  }, [inputAmount])

  useEffect(() => {
    if (paymentAmount.length > 0 && selectedInstallment > 0 && paymentAmount != null && paymentAmount != "" && paymentAmount != "0.00") {
      setAmountForView(paymentAmount);
    }
  }, [paymentAmount]);

  const clearAllState = () => {
    clearCustomer(false);
    setInstallmentList([]);
    setSelectedInstallment(0);
    setPaymentComplete(false);
    setInputAmount("");
    setPaymentAmount("");
    setPaymentComplete(false);
    setInitialPaymentInformations(initialPaymentInfoState);
    setNetAmount("");
    setServiceCommissionRate("");
    setServiceCommissionAmount("")
  }

  const setInitialInstallment = (installmentItem: InstallmentListType) => {
    setSelectedInstallment(installmentItem.month);
    setPaymentAmount(formatCurrency(installmentItem.totalAmount));
  }

  const setPaymentApi_linkInitialValues = (result: any) => {
    setInitialPaymentInformations(result.paymentInfo);

    if ((getOrderResource() == 2 && result.paymentInfo.paymentProviderId == 0)) {
      setIsDynamicPaymentProvider(true);
    }

    setPaymentAmount(result.amount);
    setInputAmount(result.amount);
    setFirmInformations(result.firmInfo);
    setInvoiceInformations(result.invoiceInfo);
    setSelectedCustomerInfo(result.customerInfo);
    setLicenseInfo(result.licenseInfo);
    setCurrencyIsoCode(result.currencyIsoCode);
    setSendTypeId(result.sendTypeId);
    setInvoiceNumber(result.invoiceNumber);

    if (result.paymentInfo && result.paymentInfo.paymentProviderId > 0) {
      setInstallmentList(result.paymentInfo.enableInstallments);
      const installmentItem: InstallmentListType = result.paymentInfo.enableInstallments[0];
      setInitialInstallment(installmentItem);
    }
  }

  const selectLinkInformations = async () => {
    const linkHash = searchParams.get("hash");
    setPaymentLinkHash(linkHash || "");
    const result: any = await selectPaymentLinkInformations(linkHash || "");

    if (result.isSuccess) {
      setPaymentApi_linkInitialValues(result);
    } else {
      setlinkStatus(result.linkStatus);
    }
    setInitialLoadingVisible(false);
  }

  const selectApiPageInformations = async () => {
    const token = queryParameters.get("token");
    const result: any = await selectPaymentApiPageInformations(token || "");

    if (result.isSuccess) {
      setApiInfo({
        apiKey: result.apiKey,
        apiSecret: result.apiSecret
      });
      setPaymentApi_linkInitialValues(result);
    } else {
      setlinkStatus(result.linkStatus);
    }
    setInitialLoadingVisible(false);
  }

  const selectPublicPaymentInfo = async () => {
    setFirmInformations({
      firmLogourl: logoPath || "",
      firmShortName: firmName,
      taxCode: taxCode,
      web: web || "",
      email: email || "",
    });

    const license = {
      licenseKey: licenseKey,
      taxCode: taxCode
    }

    const result = await paymentApi.get("/payment/public/isauthenticate", null, license);

    if (result.isSuccess) {
      setInitialLoadingVisible(false);
      setLicenseInfo({
        licenseKey: licenseKey,
        taxCode: taxCode
      });
    } else {
      navigate("/404");
    }
  }

  const selectUnexpiredLinkInformations = async () => {
    const token = queryParameters.get("hash");
    setPaymentLinkHash(token || "");

    const result: any = await selectEnExpiredPaymentLinkInformations(token || "");

    if (result.isSuccess) {
      setPaymentApi_linkInitialValues(result);
    } else {
      setlinkStatus(result.linkStatus);
    }
    setInitialLoadingVisible(false);
  }

  const selectTenantInformations = () => {
    setInitialLoadingVisible(false);
    setLicenseInfo({
      licenseKey: licenseKey,
      taxCode: taxCode
    });
  }

  const getOrderResource = () => {
    switch (paymentPage) {
      case "apiPage":
        return 8;
      case "paymentLink":
      case "unexpiredLink":
        return 2;
      case "portal":
        return 1;
      case "publicPayment":
        return 6;
      default:
        return 1;
    }
  }

  const getCurrencyIsoCode = (selected: number) => {
    const index = currencyList.findIndex(w => w.currencyId == selected);

    if (index != -1) {
      return currencyList[index].currencyIsoCode;
    }
    return "949";
  }

  const getCurrencySymbol = () => {
    const index = currencyList.findIndex(w => w.currencyId == initialPaymentInformations.currencyId);

    if (index != -1) {
      return currencyList[index].currencySymbol;
    }
    return getCurrencySymbolByCurrencyId(initialPaymentInformations.currencyId || Number(currencyIsoCode));
  }

  const selectInstallmentList = async (paymentProvider?: number) => {
    if ((isPaymentLink || isUnexpiredPaymentPage) && initialPaymentInformations.enableInstallments && initialPaymentInformations.enableInstallments?.length > 0 && !initialPaymentInformations.isAmountEditable) {
      return;
    }

    const amount = removeAmountDots(inputAmount);
    const cardBin = cardInformationRef.current?.getCardBin() || "";
    const vpId = getPaymentProviderIdForInstallmentSelect(paymentProvider) || 0;

    if ((cardBin.length >= 8 || vpId > 0) && parseInt(amount) > 0) {
      setDisablePost(true);
      setInstallmentLoading(true);

      var currencyIsoCode = getCurrencyIsoCode(initialPaymentInformations.currencyId);
      const linkHash = searchParams.get("hash") || "";

      const params = {
        CardNumber: cardBin,
        Amount: amount,
        PaymentProviderId: vpId,
        IsApplyCommission: (initialPaymentInformations.isApplyComission),
        CurrencyIsoCode: currencyIsoCode,
        CustomerId: selectedCustomerInfo.customerId || selectedCustomerInfo.customerid,
        ApiInfo: "",
        linkRequestHash: linkHash,
      }

      if (getOrderResource() == 8) {
        const { apiKey, apiSecret } = apiInfo;
        const headerAuth = btoa(apiKey + ":" + apiSecret);
        params.ApiInfo = headerAuth;
      }

      const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
      const { data, errorMessage, isSuccess } = await paymentApi.get("/installments", params, apiParams);

      setInstallmentLoading(false);
      setDisablePost(false);

      if (isSuccess) {
        if (data.minAmountAlert || data.maxAmountAlert) {
          setInstallmentList(data.installmentList);
          setInstallmentLimitError(data.minAmountAlert || data.maxAmountAlert);
          setInitialPaymentInformations({
            ...initialPaymentInformations,
            paymentProviderId: data.vpId,
            manufacturerCard: data.manufacturerCard
          });
        } else {
          setInstallmentLimitError("");
          setInstallmentList(data.installmentList);
          setInitialPaymentInformations({
            ...initialPaymentInformations,
            paymentProviderId: data.vpId,
            manufacturerCard: data.manufacturerCard
          });
          setPaymentAmount(data.amount);
          setAmountForView(data.amount);
          if (data.installmentList?.length > 0 && selectedInstallment == 0) {
            setInitialInstallment(data.installmentList[0]);
          }
        }
        setSelectedInstallment(1);
      } else {
        setInstallmentList([]);
        toast.error(errorMessage);
      }
    }
  }

  const expireDateValidate = (expire: string) => {
    var expireList = expire.split("/");
    if (expireList.length > 0) {
      if (expireList.length == 1) {
        return false;
      } else {
        var month = parseInt(expireList[0]?.trim());
        var year = parseInt(expireList[1]?.trim());
        if (month < 1 || month > 12) {
          return false;
        } else {
          year = 2000 + year;
          var nowYear = new Date().getFullYear();
          if (year < nowYear) {
            return false;
          }
        }
      }
    } else {
      return false;
    }
    return true;
  }

  const isPaymentDescRequired = () => {
    let isRequired = false;
    if (isApiPayment && initialPaymentInformations.paymentDescriptionVisible) {
      isRequired = initialPaymentInformations.paymentDescriptionRequired || false;
    }
    return isRequired;
  }

  const submitPaymentControl = () => {
    let validationErrors: Array<PaymentValidationType> = [];
    const cardInfo = cardInformationRef.current?.getCardInformations();
    const paymentDesc = paymentDescriptionRef.current?.getDescription();

    if (selectedCustomerInfo.isManuelInput != true && isWebPortal && !((selectedCustomerInfo.customerId || 0) > 0)) {
      validationErrors.push({ name: "customerId" });
    }
    let cardNumber = cardInfo?.cardNumber?.replace(/ /g, '') || "";
    if (selectedCustomerInfo.isManuelInput == true || isOnlyManuelCustomer) {
      if (!isValidEmailAddress(selectedCustomerInfo.email || "")) {
        validationErrors.push({ name: "email" });
      }
      if (selectedCustomerInfo.customerName == null || selectedCustomerInfo.customerName == "") {
        validationErrors.push({ name: "customerName" });
      }
    }
    if (isPaymentAmountVisible() && !isAmountValid(inputAmount)) {
      validationErrors.push({ name: "inputAmount" });
    }
    if (installmentLimitError.length > 0) {
      validationErrors.push({ name: "installmentLimit" });
    }
    if (isPaymentDescRequired() && paymentDesc?.length == 0) {
      validationErrors.push({ name: "paymentDesc" });
    }
    if (!cardInfo?.cardHolderName) {
      validationErrors.push({ name: "cardHolderName" });
    }
    if (!cardInfo?.cardNumber) {
      validationErrors.push({ name: "cardNumber" });
    }
    if (!cardInfo?.cvc) {
      validationErrors.push({ name: "cvc" });
    }
    if (!expireDateValidate(cardInfo?.expireDate || "")) {
      validationErrors.push({ name: "expireDate" });
    }
    if (!(selectedInstallment > 0)) {
      validationErrors.push({ name: "selectedInstallment" });
    }
    if (validationErrors.length > 0) {
      try {
        if (validationErrors[0].name == "customerId") {
          toast.error("Lütfen müşteri seçiniz.");
          return;
        }
        if (validationErrors[0].name == "email") {
          toast.error("Lütfen geçerli bir e-posta adresi giriniz.");
          return;
        }
        if (validationErrors[0].name == "customerName") {
          toast.error("Lütfen müşteri adını giriniz.");
          return;
        }
        if (validationErrors[0].name == "inputAmount") {
          toast.error("Lütfen geçerli bir tutar giriniz.");
          return;
        }
        if (validationErrors[0].name == "installmentLimit") {
          toast.error("Lütfen Taksit seçiniz.")
          return;
        }
        if (validationErrors[0].name == "paymentDesc") {
          toast.error("Lütfen açıklama giriniz.");
          return;
        }
        if (validationErrors[0].name == "cardHolderName") {
          toast.error("Lütfen kart üzerindeki ismi giriniz.");
          return;
        }
        if ((cardNumber?.length <= 14 && validationErrors.length == 0 || validationErrors[0].name == "cardNumber")) {
          // validationErrors.push({ name: "cardNumber" });
          toast.error("Lütfen 16 haneli kart numarası giriniz.");
          return;
        }
        if (validationErrors[0].name == "cvc") {
          toast.error("Lütfen kartın cvv numarasını giriniz.");
          return;
        }
        if (validationErrors[0].name == "expireDate") {
          toast.error("Lütfen kartın son kullanma tarihini giriniz.");
          return;
        }
      } catch (error) {

      }
      finally {
        dispatch(updatePaymentValidationErrors(validationErrors));
      }
    }

    if (validationErrors.length == 0) {
      dispatch(updatePaymentValidationErrors([]));
      if (selectedInstallment == 0) {
        toast.error("Lütfen taksit seçiniz.");
      } else {
        postPayment();
      }
    } else {
      dispatch(updatePaymentValidationErrors(validationErrors));
      toast.error("Lütfen zorunlu alanları doldurunuz.");
    }
  }

  const postPayment = async () => {
    const cardInfo = cardInformationRef.current?.getCardInformations();
    const paymentDesc = paymentDescriptionRef.current?.getDescription();
    var currencyIsoCode = getCurrencyIsoCode(initialPaymentInformations.currencyId);

    const { address, city, country, customerCode, customerId, customerName, district, email, isManuelInput,
      phone, taxOffice, tcCode, customerid } = selectedCustomerInfo;
    const installmentItem = installmentList.find(w => w.month == selectedInstallment);

    var splList = cardInfo?.expireDate.split("/") || [];
    var month = splList[0].trim() + "";

    if (month.length == 1) {
      month = "0" + month;
    }

    const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
    const createUserId = isWebPortal ? localStorage.getItem(USER_ID) : 0;
    let invoicePaymentDate = null;

    if (invoiceInformations?.invoicePaymentDate) {
      invoicePaymentDate = moment.utc(invoiceInformations.invoicePaymentDate).toDate();
    }

    let invoiceDate = null;

    if (invoiceInformations?.invoiceDate) {
      invoiceDate = moment.utc(invoiceInformations.invoiceDate).toDate();
    }

    let params: any;
    let response: ApiResponseType;
    setPostLoading(true);

    if (getOrderResource() == 8) {
      const token = queryParameters.get("token");
      var month = splList[0].trim() + "";

      if (month.length == 1) {
        month = "0" + month;
      }

      const { apiKey, apiSecret } = apiInfo;
      const headerAuth = btoa(apiKey + ":" + apiSecret);

      params = {
        CardHolderName: cardInfo?.cardHolderName,
        CardHash: cardInfo?.cardNumber?.replaceAll(" ", ""),
        ExpireMonth: parseInt(month),
        ExpireYear: parseInt(splList[1].trim()),
        CvvCode: cardInfo?.cvc,
        Installment: selectedInstallment,
        OrderDesc: paymentDesc,
        OrderResource: getOrderResource(),
        Paymentprovider: initialPaymentInformations.paymentProviderId,
        ManufacturerCard: initialPaymentInformations.manufacturerCard,
        amount: paymentAmount,
        firstAmount: (paymentAmount + "").replaceAll(".", "").replaceAll(",", "") + "",
        ApiInfo: headerAuth,
        Token: token
      };

      const formData = new FormData();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value.toString());
        }
      });

      response = await paymentApi.post("/paymentform/payment-post", formData, apiParams);

    } else {
      params = {
        CustomerName: customerName,
        CustomerCode: customerCode,
        TaxCode: selectedCustomerInfo.taxCode,
        TaxOffice: taxOffice,
        TcCode: tcCode,
        IpAddress: "",
        PostalCode: "",
        Adress: address,
        Email: email,
        Phone: phone,
        CardHolderName: cardInfo?.cardHolderName,
        CardNumber: cardInfo?.cardNumber?.replaceAll(" ", ""),
        ExpireMonth: parseInt(month),
        ExpireYear: parseInt(splList[1].trim()),
        CvvCode: cardInfo?.cvc,
        Installment: selectedInstallment,
        OrderDesc: paymentDesc,
        amount: paymentAmount,
        firstAmount: (paymentAmount + "").replaceAll(".", "").replaceAll(",", "") + "",
        OrderResource: getOrderResource(),
        CreateUserId: createUserId,
        PaymentProvider: initialPaymentInformations.paymentProviderId,
        ManufacturerCard: initialPaymentInformations.manufacturerCard,
        CallbackUrl: "",
        ExtraInstallmentCount: installmentItem?.extraInstallmentCount,
        InstallmentDeferralCount: installmentItem?.deferralCount,
        BillingAddress: {},
        ShippingAddress: {},
        BasketItems: [],
        CurrencyIsoCode: currencyIsoCode,
        CustomerId: customerId || customerid,
        LinkRequestID: paymentLinkHash,
        InvoiceNumber: invoiceInformations?.invoiceNumber || "",
        GibInvoiceNumber: invoiceInformations?.gibInvoiceNumber || "",
        InvoiceDate: invoiceDate,
        InvoicePaymentDate: invoicePaymentDate,
        InvoicePaymentDay: invoiceInformations?.invoiceDay || 0,
        MonthlyComission: installmentItem?.monthlyComission,
        sendTypeId: sendTypeId
      };
      response = await paymentApi.post("/payment/threed-post", params, apiParams);
    }

    setPostLoading(false);

    if (response.isSuccess) {
      threedPopupRef.current?.postPayment(response.data.threedHtml);
    } else {
      toast.error(response.errorMessage);
    }
  }

  const isPaymentAmountVisible = () => {
    const paymentAmountTypeVisible = paymentHelpers.isPaymentAmountTypeVisible(paymentPage);
    if (paymentAmountTypeVisible) {
      return true;
    }
    return initialPaymentInformations.isAmountEditable || false;
  }

  const isPaymentProviderAreaVisible = () => {
    if (isBankUser) {
      return false;
    }
    const paymentproviderVisible = paymentHelpers.isPaymentProviderAreaVisible(paymentPage);
    if (paymentproviderVisible) {
      return true;
    }
    if (isApiPayment && initialPaymentInformations.isPaymentProviderSelectable) {
      return true;
    }
    return false;
  }

  const onChangePaymentprovider = (item: PaymentProviderListType) => {
    setInitialPaymentInformations({
      ...initialPaymentInformations,
      paymentProviderId: item.vpid,
    });
    selectInstallmentList(item.vpid);
  }

  const setIsPaymentProviderSelectable = (isSelect: boolean) => {
    setInitialPaymentInformations({
      ...initialPaymentInformations,
      isPaymentProviderSelectable: isSelect,
    });
  }

  const getPaymentProviderIdForInstallmentSelect = (paymentProvider?: number) => {
    if (initialPaymentInformations.isPaymentProviderSelectable) {
      return paymentProvider || initialPaymentInformations.paymentProviderId || initialPaymentInformations.initialPaymentProviderId;

    } else if ((isPaymentLink || isApiPayment) && initialPaymentInformations.initialPaymentProviderId &&
      initialPaymentInformations.initialPaymentProviderId > 0) {
      return initialPaymentInformations.initialPaymentProviderId;
    } else if (isUserVp) {
      return defaultUserVp;
    }
    return 0;
  }

  const clearCustomer = (isManuelInput: boolean) => {
    setSelectedCustomerInfo({
      ...initialCustomerInfo,
      isManuelInput: isManuelInput
    });
  }

  const onPaymentComplete = (parameters: string) => {
    let params = JSON.parse(parameters);
    setCompletedPaymentParameters({
      ...params
    });
    setPaymentComplete(true);
  }
  const goToPayment = (isReset: boolean) => {
    clearAllState();
  }

  const getResultPage = () => {
    return (
      <PaymentResultV1 {...completedPaymentParameters} paymentPageType={paymentPage}
        goToPayment={goToPayment}
      />
    );
  }

  const getHeaderNav = () => (
    <div className={`h-[50px] bg-primary-navbar mt-8 flex justify-center mb-8  w-[788px] sm:w-full xs:w-full sm_2:w-full rounded-md m-auto`}>
      <img className="max-h-full" src="/images/elogologo.svg" />
    </div>
  )

  const AmountBalanceArea = () => {
    return (
      !(isWebPortal && (tenantValue.firmInformations.isCustomerBalance)) ?
        <AmountInformationArea ref={amountInformationRef} isCustomerBalance={isWebPortal && (tenantValue.firmInformations.isCustomerBalance)}
          customerId={selectedCustomerInfo.customerId || 0} amount={amountForView}
          description={initialPaymentInformations.description}
          isPaymentLink={isPaymentLink} gibInvoiceNumber={invoiceInformations?.gibInvoiceNumber}
          invoiceNumber={invoiceInformations?.invoiceNumber} invoicePaymentDate={invoiceInformations?.invoicePaymentDate}
          invoiceDate={invoiceInformations?.invoiceDate} currencyId={initialPaymentInformations.currencyId || Number(currencyIsoCode)}
        /> :
        <CustomerAmountInformationArea
          customerId={selectedCustomerInfo.customerId || 0}
          description={initialPaymentInformations.description}
          isPaymentLink={isPaymentLink} gibInvoiceNumber={invoiceInformations?.gibInvoiceNumber}
          invoiceNumber={invoiceInformations?.invoiceNumber} invoicePaymentDate={invoiceInformations?.invoicePaymentDate}
          invoiceDate={invoiceInformations?.invoiceDate} currencyId={initialPaymentInformations.currencyId || Number(currencyIsoCode)}
        />
    );
  }

  if (paymentComplete) {
    return getResultPage();
  }
  if (initialLoadingVisible) {
    return (
      <Loading />
    );
  }


  if (!isWebPortal && (linkStatus !== "available" && linkStatus != "")) {

    return <RouteErrorByStatus linkStatus={linkStatus} />
  }

  const getDescriptionArea = () => (
    <PaymentDescriptionArea ref={paymentDescriptionRef}
      isVisible={isApiPayment ? (initialPaymentInformations.paymentDescriptionVisible || false) : true} />
  )

  const isCustomerTypeVisible = () => {
    if (isWebPortal && isAuthorizeToFreePayment()) {
      return true;
    } else {
      return false;
    }
  }

  async function handleUserPaymentPermissions() {
    if (!isWebPortal) return;
    let result: ApiResponseType;
    const params = {
      userId: userId
    }
    result = await commonNetwork.get("/user/" + userId, params);

    if (result.isSuccess) {
      const data = result.data;
      if (data.bankId > 0) {
        setIsUserVp(true);
        setInitialPaymentInformations((prevState) => ({
          ...prevState,
          paymentProviderId: data.bankId
        }));
        setDefaultUserVp(data.bankId);
      }
    }
    else {
      console.warn("Kullanıcı bilgileri alınamadı.");
    }
  }

  return (
    <>
      <PageTitle title={pageTitleTexts.paymentPageV1} />
      <ThreedPopup ref={threedPopupRef} onPaymentComplete={onPaymentComplete} />
      {headerNavVisible && getHeaderNav()}
      <div className={`w-full ${headerNavVisible ? "mt-4" : "mt-8"} flex justify-center  mb-8 md:flex-row sm_2:flex-col sm:flex-col xs:flex-col `}
        id="payment-content" >
        <div className=" px-8  bg-white rounded-tl-lg rounded-bl-lg ">
          <div className="w-[330px] sm:w-full xs:w-full sm_2:w-full">
            {isFirmInfoVisible && (
              <FirmInformationArea email={firmInformations.email}
                firmName={firmInformations.firmShortName}
                taxCode={firmInformations.taxCode}
                web={firmInformations.web} logourl={firmInformations.firmLogourl}
              />
            )}
            {isCustomerSelectVisible && (
              <CustomerSelect selectedCustomerInfo={selectedCustomerInfo} setSelectedCustomerInfo={setSelectedCustomerInfo}
                clearCustomer={clearCustomer} isCustomerTypeVisible={isCustomerTypeVisible()} isOnlyManuelCustomer={isOnlyManuelCustomer} />
            )}
            {isAmountAreaVisible && !isWebPortal && <AmountBalanceArea />}
            {customerInformationVisible && (
              <CustomerInformationArea selectedCustomerInfo={selectedCustomerInfo} paymentPage={paymentPage} />
            )}
            {isAmountAreaVisible && isWebPortal && isUserAuthorizeToMenu({
              key: "balanceQuery",
              label: "Bakiye Sorgula",
              authorizationTypes: [UserOperationTypes["Erp Bakiye Sorgula"]]
            }) && <AmountBalanceArea />}
            {
              !isWebPortal && (
                <FirmDescriptionArea isShortView={isFirmInfoVisible} paymentDesc={initialPaymentInformations.longDescription || ""} />
              )
            }
          </div>
          <div className=" mb-10" />
        </div>
        <div className=" p-8 pt-6 bg-white rounded-tr-2xl rounded-br-2xl shadow  ">
          <div className="w-[330px]  sm:w-full xs:w-full  sm_2:w-full">
            {(isApiPayment && invoiceNumber != null && invoiceNumber !== "") ? (
              <div className="w-full bg-white mt-6 mb-3">
                <GroupTitle title="Fatura Numarası" />
                <p className="text-lg mt-[5px] font-bold text-black">{invoiceNumber}</p>
              </div>
            ) : null}
            <PaymentMasterArea amount={inputAmount} paymentAmountTypeVisible={isWebPortal && isBankUser != true}
              setAmount={setInputAmount}
              customerId={selectedCustomerInfo?.customerId || 0} amountVisible={isPaymentAmountVisible()}
              descriptionVisible={isApiPayment ? (initialPaymentInformations.paymentDescriptionVisible || false) : true}
              selectedCurrency={initialPaymentInformations.currencyId}
              setSelectedCurrency={(currencyId) => setInitialPaymentInformations({
                ...initialPaymentInformations,
                currencyId: currencyId
              })}
            />
            {isPaymentAmountVisible() && getDescriptionArea()}
            {paymentPage == "portal" && isAuthorizeToComission() && isCommissionSelectable() && (
              <Checkbox
                label={"Komisyon Uygulanmasın"}
                name={"isDisableComission"}
                inputContainerClass=" mt-4"
                id="isDisableComission"
                type="checkbox"
                onChange={(e: any) => {
                  setInitialPaymentInformations({
                    ...initialPaymentInformations,
                    isApplyComission: !e.target.checked
                  })
                }}
                defaultValue={!initialPaymentInformations.isApplyComission}
              />
            )}
            {((isWebPortal || isPaymentLink) && (initialPaymentInformations.currencyId || 1) == 1 && parameters?.isShowInstallment) && !((initialPaymentInformations.initialPaymentProviderId || 0) > 0) && (
              <HtmlTableButton licenseKey={licenseInfo.licenseKey} paymentAmount={inputAmount} taxCode={licenseInfo.taxCode} />
            )}
            <CardInformationArea ref={cardInformationRef}
              licenseKey={licenseInfo.licenseKey} taxCode={licenseInfo.taxCode}
              selectInstallmentList={selectInstallmentList}
            />
            {!isPaymentAmountVisible() && getDescriptionArea()}
            {isPaymentProviderAreaVisible() && licenseInfo.licenseKey && (
              <PaymentProvidersV1 currencyId={initialPaymentInformations.currencyId} licenseKey={licenseInfo.licenseKey} taxCode={licenseInfo.taxCode}
                selectedPaymentProvider={initialPaymentInformations.paymentProviderId || 0}
                onChangeSelected={onChangePaymentprovider}
                isPaymentProviderSelectable={initialPaymentInformations.isPaymentProviderSelectable || false}
                setIsPaymentProviderSelectable={setIsPaymentProviderSelectable}

              />
            )}
            <InstallmentListV1 selectedInstallment={selectedInstallment} loading={installmentLoading}
              setSelected={(item) => setSelectedInstallment(item.month)} installmentList={installmentList}
              limitError={installmentLimitError} setPaymentAmount={setPaymentAmount}
              currencySymbol={getCurrencySymbol()} setNetAmount={setNetAmount} selectedPaymentProvider={initialPaymentInformations.paymentProviderId || 0}
              setServiceCommissionRate={setServiceCommissionRate} setServiceCommissionAmount={setServiceCommissionAmount}
            />
            <CostArea netAmount={netAmount} serviceCommissionRate={serviceCommissionRate}
              isShowCost={isShowCost} isWebPortal={isWebPortal}
              currencySymbol={getCurrencySymbol()} serviceCommissionAmount={serviceCommissionAmount}
            />
            <PaymentContractArea licenseKey={licenseInfo.licenseKey} taxCode={licenseInfo.taxCode} />
            <Button
              type="button"
              callback={submitPaymentControl}
              color="primary"
              hover="primary"
              className={" mt-6 px-7 py-3 w-full"}
              size="xl"
              loading={postLoading}
              disabled={disablePost || installmentLoading || (installmentLimitError.length > 0) || postLoading}
            >
              {amountForView || "0.00"} {getCurrencySymbol()} {initialPaymentInformations.payButtonTitle || "Öde"}
            </Button>
            <div className="flex items-center justify-center mt-6">
              <img src="/images/visa-mastericons.svg" className="w-auto h-[32px] " alt="master-visa" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default PaymentPageV1;

String.prototype.replaceAll = function (search, replacement: any) {
  var target = this;
  return target.split(search).join(replacement);
};